import { defineMessages } from 'react-intl';

export const externalBannerCardMessages = defineMessages({
  'external-banner-expires-on-chip': {
    id: 'external-banner-expires-on-chip',
    defaultMessage: 'Expires on {date}',
    description: 'Shown on the external banner card',
  },
  'external-banner-activate-before-chip': {
    id: 'external-banner-activate-before-chip',
    defaultMessage: 'Activate before {date}',
    description: 'Shown on the external banner card',
  },
});
